import {AppMode, PositionChangeProps} from '@dv5/domain'
import React, {useRef} from 'react'
import {Icon, IconName} from "./Icon"
import './ArrangeButtons.less'

interface ArrangeButtonsProps {
    arrangeProps: PositionChangeProps
    onSwap: (index: number, down: boolean) => void
    className?: string
}

export const ArrangeButtons: React.FC<ArrangeButtonsProps> = ({
                                                                  arrangeProps,
                                                                  onSwap,
                                                                  className = ''
                                                              }) => {
    const upButtonRef = useRef<HTMLButtonElement>(null)
    const downButtonRef = useRef<HTMLButtonElement>(null)

    const handleUpClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        if (arrangeProps.index > 0) {
            onSwap(arrangeProps.index, false)
        }
    }

    const handleDownClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        event.stopPropagation()
        if (arrangeProps.index < arrangeProps.count - 1) {
            onSwap(arrangeProps.index, true)
        }
    }

    if (arrangeProps.mode == AppMode.VIEW) {
        return null
    }
    let firstIcon = IconName.Up
    if (arrangeProps.groupCount > 1) {
        if (arrangeProps.index % arrangeProps.groupCount === 0) {
            firstIcon = IconName.RightUp
        } else {
            firstIcon = IconName.Left
        }
    }
    let secondIcon = IconName.Down
    if (arrangeProps.groupCount > 1) {
        if (arrangeProps.index % arrangeProps.groupCount === arrangeProps.groupCount - 1) {
            secondIcon = IconName.LeftDown
        } else {
            secondIcon = IconName.Right
        }
    }

    return (
        <div className={`arrange-buttons-container ${className}`}>
            <div className="button-container">
                <button
                    ref={upButtonRef}
                    className="arrange-button"
                    onMouseDown={handleUpClick}
                    disabled={arrangeProps.index === 0}
                    aria-label="Move up"
                    title="Move up"
                >
                    <Icon
                        name={firstIcon}
                        className="arrange-icon"
                        width="20"
                        height="20"
                    />
                </button>
            </div>

            <div className="button-container">
                <button
                    ref={downButtonRef}
                    className="arrange-button"
                    onMouseDown={handleDownClick}
                    disabled={arrangeProps.index >= arrangeProps.count - 1}
                    aria-label="Move down"
                    title="Move down"
                >
                    <Icon
                        name={secondIcon}
                        className="arrange-icon"
                        width="20"
                        height="20"
                    />
                </button>
            </div>
        </div>
    )
}
